import React from 'react';
import {HashRouter} from 'react-router-dom';
import AssignQuotePopup from '../../bvcomponents/popups/assignQuotePopup/assignQuotePopup';
import LoaderView from '../../bvcomponents/ui/loaderView';
import FatalErrorRecoveryPopup from './FatalErrorRecoveryPopup';
import {reportFatalError} from './errorReporter';

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      hasError: false,
    };
  }

  static getDerivedStateFromError() {
    return {
      hasError: true,
    };
  }

  componentDidCatch(error, errorInfo) {
    reportFatalError('react-error-boundary', error, {
      reactStack: errorInfo && errorInfo.componentStack,
    });
  }

  render() {
    if (this.state.hasError) {
      return (
        <React.Fragment>
          <FatalErrorRecoveryPopup/>
          <HashRouter>
            <React.Fragment>
              <AssignQuotePopup/>
              <LoaderView/>
            </React.Fragment>
          </HashRouter>
        </React.Fragment>
      );
    }

    return this.props.children;
  }
}
